import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../app/http/axiosClient";
import Header from "../../app/universalComponents/Header";
import Footer from "../../app/universalComponents/Footer";
import Placeholder from "../../assets/images/placeholderPoster.png";
import Loading from "../../app/universalComponents/Loading";

export default function HomePage() {
    const [error, setError] = useState(false);
    const [events_current, setEvents_current] = useState(null);
    const [events_past, setEvents_past] = useState(null);

    useEffect(() => {
        async function getEventList() {
            try {
                setError(false);

                const response = await api.get("/public/events");

                setEvents_current(response.data.events_current || []);
                setEvents_past(response.data.events_past || []);
            } catch (err) {
                setError(true);
            }
        }

        getEventList();
    }, []);

    useEffect(() => {
        document.title = "Happening Now | Tickets.NP";
    }, []);

    if (error) {
        return <p>No Events Found</p>;
    }

    if (!events_current || !events_past) {
        return <Loading fullPage />;
    }

    return (
        <>
            <Header sellTickets={true} />

            <main className="">
                <section className="mb-8 mx-6 py-8 lg:mx-20">
                    <p className="text-xs font-semibold uppercase tracking-widest text-gray-500">
                        Upcoming events
                    </p>

                    <h1 className="mt-2 text-4xl font-bold tracking-tight lg:text-5xl">
                        Find your next night out
                    </h1>
                </section>

                {events_current.length === 0 ? (
                    <p className="text-gray-500 mx-6 py-8 lg:mx-20">No events available.</p>
                ) : (
                    <section className="grid justify-items-center gap-8 sm:grid-cols-2 mx-6 lg:mx-20">
                        {events_current.map((event) => (
                            <Link
                                key={event.slug}
                                to={`/events/${event.slug}`}
                                className="group block w-full max-w-64 rounded-sm transition-transform duration-200 ease-in-out hover:scale-105"
                            >
                                <article className="overflow-hidden rounded-sm bg-white">
                                    <div className="w-full overflow-hidden border bg-gray-100">
                                        <img
                                            src={event.poster_image_key || Placeholder}
                                            alt={`${event.title} poster`}
                                            className="h-full w-full object-contain"
                                        />
                                    </div>

                                    <div className="border-x border-b border-gray-300 bg-white p-4 shadow-sm">
                                        <p className="text-xs font-semibold uppercase tracking-widest text-gray-500">
                                            {event.date}
                                        </p>

                                        <h2 className="mt-1 text-xl font-bold tracking-tight text-gray-900">
                                            {event.title}
                                        </h2>

                                        <p className="mt-1 text-sm font-semibold text-gray-500">
                                            {event.organiser}
                                        </p>
                                    </div>
                                </article>
                            </Link>
                        ))}
                    </section>
                )}

                <section className="mt-12 bg-gray-200 px-6 py-8 lg:px-20">
                    <div className="mb-6 text-center">
                        <p className="text-xs font-semibold uppercase tracking-widest text-gray-500">
                            Past events
                        </p>

                        <h2 className="mt-1 text-3xl font-bold tracking-tight italic">
                            Where memories happened
                        </h2>
                    </div>

                    <div className="mx-auto grid max-w-5xl grid-cols-2 gap-4 lg:grid-cols-4 lg:gap-6">
                        {events_past.map((event) => (
                            <article
                                key={event.slug}
                                className="overflow-hidden rounded-sm transition-transform duration-200 ease-in-out hover:scale-105"
                            >
                                <img
                                    src={event.poster_image_key || Placeholder}
                                    alt={`${event.title} poster`}
                                    className="h-full w-full object-contain"
                                />
                            </article>
                        ))}
                    </div>
                </section>
            </main>

            <Footer />
        </>
    );
}